module.exports = __webpack_public_path__ + "img/horizontal_standart.a21918d5.svg";